import { useStore } from "@nanostores/preact";
import { useEffect, useState } from "preact/hooks";
import { verifyChain, type VerifyResult } from "../ledger/verify";
import { getHistory, type HistoryResponse } from "../net/api";
import { $historyCode, $panel } from "../state/stores";
import { Panel } from "./Panel";

const kindLabel: Record<string, string> = { mint: "鑄造", transfer: "轉讓", policy: "政策" };

export function AssetHistoryPanel() {
  const code = useStore($historyCode);
  const [h, setH] = useState<HistoryResponse | null>(null);
  const [local, setLocal] = useState<VerifyResult | null>(null);
  useEffect(() => { if (code) void getHistory(code).then(setH); }, [code]);
  if (!code) return null;

  return (
    <Panel title={`歷史 ${code}`} onClose={() => $panel.set("inventory")}>
      {!h ? <p class="hint">載入中…</p> : (
        <>
          <p class="hint">伺服器驗證：{h.verified ? "通過" : "失敗"}</p>
          <table>
            <thead><tr><th>#</th><th>種類</th><th>從</th><th>到</th><th>時間</th></tr></thead>
            <tbody>
              {h.entries.map((e) => (
                <tr key={e.seq}>
                  <td>{e.seq}</td><td>{kindLabel[e.kind] ?? e.kind}{e.payload && <><br /><code>{e.payload}</code></>}</td>
                  <td><code>{e.from || "—"}</code></td><td><code>{e.to}</code></td>
                  <td>{new Date(e.created_at).toLocaleString("zh-TW")}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <button onClick={() => setLocal(verifyChain(h.entries, h.keys))}>在瀏覽器驗證</button>
          {local && <div class={local.ok ? "hint" : "error"}>{local.ok ? "本機驗證通過：每筆雜湊、簽章與鏈結都正確" : `本機驗證失敗：第 ${local.seq} 筆 ${local.code}`}</div>}
        </>
      )}
    </Panel>
  );
}
